/* Global Diesel – Teileshop  |  Warenkorb-Drawer, Altteilpfand, Galerie, Karte, Suche */
(function () {
  'use strict';
  var K = window.GD || {};              // Konfiguration aus theme.liquid
  var T = K.texte || {};
  var fmt = function (cent) {
    var v = (cent / 100).toFixed(2);
    if (K.sprache === 'fr') return v.replace('.', ',') + ' €';
    return v.replace('.', ',') + ' €';
  };
  var q = function (s, el) { return (el || document).querySelector(s); };
  var qa = function (s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); };
  var root = (K.root || '/').replace(/\/$/, '');

  /* ---------- Toast ---------- */
  var toastEl;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'gd-toast'; document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('gd-offen');
    clearTimeout(toastEl._t); toastEl._t = setTimeout(function () { toastEl.classList.remove('gd-offen'); }, 2600);
  }

  /* ---------- Warenkorb ---------- */
  var drawer = q('[data-gd-drawer]'), schleier = q('[data-gd-schleier]');
  function offen(ja) {
    if (!drawer) return;
    drawer.classList.toggle('gd-offen', ja); schleier && schleier.classList.toggle('gd-offen', ja);
    document.body.style.overflow = ja ? 'hidden' : '';
  }
  function holeCart() { return fetch(root + '/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }
  function zeichne(cart) {
    qa('[data-gd-anzahl]').forEach(function (b) { b.textContent = cart.item_count; b.hidden = cart.item_count === 0; });
    if (!drawer) return;
    var box = q('[data-gd-zeilen]', drawer), summe = q('[data-gd-summe]', drawer), kasse = q('[data-gd-kasse]', drawer);
    if (!cart.items.length) {
      box.innerHTML = '<p class="gd-leer">' + (T.leer || 'Ihr Warenkorb ist leer.') + '</p>';
      if (kasse) kasse.disabled = true;
    } else {
      box.innerHTML = cart.items.map(function (it) {
        var pfand = it.handle === K.pfandHandle;
        var bild = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2') : '';
        return '<div class="gd-zeile" data-key="' + it.key + '">' +
          (bild ? '<img src="' + bild + '" alt="">' : '<span></span>') +
          '<div><b>' + (pfand && it.variant_title && it.variant_title !== 'Default Title' ? it.product_title + ' ' + it.variant_title : it.product_title) + '</b>' +
          (it.sku && !pfand ? '<small>' + (T.artnr || 'Art.-Nr.') + ' ' + it.sku + '</small>' : '') +
          (pfand ? '<small>' + (T.pfandZeile || 'Rückerstattung nach Rücksendung des Altteils') + '</small>' : '') +
          (pfand ? '' : '<div class="gd-menge"><button type="button" data-minus aria-label="−">−</button><input type="number" min="0" value="' + it.quantity + '" aria-label="' + (T.menge || 'Menge') + '"><button type="button" data-plus aria-label="+">+</button></div>') +
          '</div>' +
          '<div class="gd-zeile__preis">' + fmt(it.final_line_price) + (pfand ? '' : '<a href="#" class="gd-zeile__weg" data-weg>' + (T.entfernen || 'Entfernen') + '</a>') + '</div>' +
          '</div>';
      }).join('');
      if (kasse) kasse.disabled = false;
    }
    if (summe) summe.firstChild.textContent = fmt(cart.total_price);
    syncPfand(cart);
  }
  /* Pfandpositionen je Teileart: Variante aus _pfand_typ, Stückzahl aus _pfand (Betrag ÷ Variantenpreis) × Menge – wird nach jeder Änderung angeglichen */
  var pfandLauf = false;
  function pfandVariante(typ) {
    var V = K.pfandVarianten || {};
    return V[typ] || V.einspritzduese || null;
  }
  function pfandStueck(betrag, typ) {
    var v = pfandVariante(typ); if (!v) return 0;
    var preis = v.preis / 100;
    return Math.max(1, Math.round(betrag / (preis || K.pfandEinheit || 50)));
  }
  function syncPfand(cart) {
    if (!K.pfandHandle || pfandLauf) return;
    var soll = {}, ist = {};
    cart.items.forEach(function (it) {
      if (it.handle === K.pfandHandle) { ist[it.variant_id] = it; return; }
      var p = (it.properties && it.properties._pfand) ? parseInt(it.properties._pfand, 10) : 0;
      if (!p) return;
      var typ = (it.properties && it.properties._pfand_typ) || 'einspritzduese', v = pfandVariante(typ);
      if (!v) return;
      soll[v.id] = (soll[v.id] || 0) + pfandStueck(p, typ) * it.quantity;
    });
    var aufgaben = [];
    Object.keys(ist).forEach(function (vid) { if ((soll[vid] || 0) !== ist[vid].quantity) aufgaben.push({ key: ist[vid].key, menge: soll[vid] || 0 }); });
    Object.keys(soll).forEach(function (vid) { if (!ist[vid] && soll[vid] > 0) aufgaben.push({ id: +vid, menge: soll[vid] }); });
    if (!aufgaben.length) return;
    pfandLauf = true;
    var kette = Promise.resolve();
    aufgaben.forEach(function (a) {
      kette = kette.then(function () {
        if (a.key) return aendere(a.key, a.menge);
        return fetch(root + '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ id: a.id, quantity: a.menge }) });
      });
    });
    kette.then(function () {
      pfandLauf = false;
      holeCart().then(zeichne);
      if (document.body.classList.contains('template-cart')) location.reload();
    }, function () { pfandLauf = false; });
  }
  function aendere(key, menge) {
    return fetch(root + '/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: menge }) }).then(function (r) { return r.json(); });
  }
  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var zeile = e.target.closest('.gd-zeile'); if (!zeile) return;
      var inp = q('input', zeile), key = zeile.getAttribute('data-key'), menge;
      if (e.target.closest('[data-minus]')) menge = Math.max(0, +inp.value - 1);
      else if (e.target.closest('[data-plus]')) menge = +inp.value + 1;
      else if (e.target.closest('[data-weg]')) { e.preventDefault(); menge = 0; }
      else return;
      aendere(key, menge).then(zeichne);
    });
    drawer.addEventListener('change', function (e) {
      var zeile = e.target.closest('.gd-zeile'); if (!zeile || e.target.tagName !== 'INPUT') return;
      aendere(zeile.getAttribute('data-key'), Math.max(0, +e.target.value)).then(zeichne);
    });
    qa('[data-gd-schliessen]', drawer).forEach(function (b) { b.addEventListener('click', function () { offen(false); }); });
    schleier && schleier.addEventListener('click', function () { offen(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') offen(false); });
    qa('[data-gd-oeffnen]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); holeCart().then(function (c) { zeichne(c); offen(true); }); }); });
  }
  holeCart().then(zeichne).catch(function () {});

  /* Flug-Animation: Bild fliegt zum Korb-Symbol */
  function flug(img) {
    var ziel = q('[data-gd-oeffnen]'); if (!img || !ziel) return;
    var a = img.getBoundingClientRect(), z = ziel.getBoundingClientRect();
    var f = document.createElement('img'); f.src = img.currentSrc || img.src; f.className = 'gd-flug';
    f.style.left = (a.left + a.width / 2 - 30) + 'px'; f.style.top = (a.top + a.height / 2 - 30) + 'px';
    document.body.appendChild(f);
    requestAnimationFrame(function () {
      f.style.transform = 'translate(' + (z.left + z.width / 2 - (a.left + a.width / 2)) + 'px,' + (z.top + z.height / 2 - (a.top + a.height / 2)) + 'px) scale(.2)';
      f.style.opacity = '0';
    });
    setTimeout(function () { f.remove(); }, 800);
  }

  /* In den Warenkorb (Produktseite + Produktkarten) */
  function hinzu(variant, menge, pfand, typ, bild, knopf) {
    if (knopf) knopf.disabled = true;
    var item = { id: variant, quantity: menge }, items = [item], v = pfandVariante(typ), stueck = 0;
    if (pfand) {
      item.properties = { _pfand: pfand, _pfand_typ: typ || 'einspritzduese' };
      /* Pfand im selben Aufruf mitlegen – so landet es garantiert im Warenkorb, syncPfand gleicht später nur noch an */
      if (v) { stueck = pfandStueck(pfand, typ) * menge; items.push({ id: v.id, quantity: stueck }); }
    }
    return fetch(root + '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin',
      body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () { flug(bild); return holeCart(); })
      .then(function (c) { zeichne(c); offen(true); toast((T.hinzugefuegt || 'In den Warenkorb gelegt') + (pfand ? ' · ' + stueck + '× ' + (K.sprache === 'fr' ? 'consigne' : 'Altteilpfand') + ' ' + fmt(pfand * 100 * menge) : '')); })
      .catch(function (r) {
        var m = T.fehler || 'Konnte nicht hinzugefügt werden.';
        if (r && r.json) r.json().then(function (j) { toast(j.description || m); }); else toast(m);
      })
      .then(function () { if (knopf) knopf.disabled = false; });
  }
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f.hasAttribute('data-gd-kauf')) return;
    e.preventDefault();
    var variant = +f.querySelector('[name="id"]').value, mengeEl = f.querySelector('[name="quantity"]');
    var pfand = +(f.getAttribute('data-pfand') || 0), typ = f.getAttribute('data-pfand-typ') || '', bild = q('[data-gd-hauptbild]') || f.closest('.gd-karte-p') && q('img', f.closest('.gd-karte-p'));
    hinzu(variant, mengeEl ? Math.max(1, +mengeEl.value) : 1, pfand, typ, bild, f.querySelector('[type="submit"]'));
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-gd-schnell]'); if (!b) return;
    e.preventDefault();
    hinzu(+b.getAttribute('data-variant'), 1, +(b.getAttribute('data-pfand') || 0), b.getAttribute('data-pfand-typ') || '', q('img', b.closest('.gd-karte-p')), b);
  });

  /* Mengenfeld auf der Produktseite */
  document.addEventListener('click', function (e) {
    var m = e.target.closest('.gd-menge'); if (!m || m.closest('.gd-zeile')) return;
    var inp = q('input', m);
    if (e.target.closest('[data-minus]')) inp.value = Math.max(1, +inp.value - 1);
    if (e.target.closest('[data-plus]')) inp.value = +inp.value + 1;
  });

  /* Galerie */
  qa('[data-gd-galerie]').forEach(function (g) {
    var haupt = q('[data-gd-hauptbild]', g);
    qa('.gd-galerie__vorschau button', g).forEach(function (b) {
      b.addEventListener('click', function () {
        qa('.gd-galerie__vorschau button', g).forEach(function (x) { x.removeAttribute('aria-current'); });
        b.setAttribute('aria-current', 'true');
        haupt.src = b.getAttribute('data-src'); haupt.srcset = b.getAttribute('data-srcset') || '';
      });
    });
  });

  /* Mobile Filter */
  var filter = q('[data-gd-filter]');
  qa('[data-gd-filter-knopf]').forEach(function (b) { b.addEventListener('click', function () { filter && filter.classList.add('gd-offen'); }); });
  qa('[data-gd-filter-zu]').forEach(function (b) { b.addEventListener('click', function () { filter && filter.classList.remove('gd-offen'); }); });
  /* Filter-Formular: Änderungen sofort absenden (Desktop) */
  if (filter) qa('input[type=checkbox]', filter).forEach(function (c) {
    c.addEventListener('change', function () { if (window.innerWidth > 900) filter.querySelector('form').submit(); });
  });
  var sortier = q('[data-gd-sortierung]');
  if (sortier) sortier.addEventListener('change', function () {
    var u = new URL(location.href); u.searchParams.set('sort_by', sortier.value); u.searchParams.delete('page'); location.href = u.toString();
  });

  /* Google-Maps-Karte erst nach Klick laden (Datenschutz) */
  qa('[data-gd-karte-laden]').forEach(function (b) {
    b.addEventListener('click', function () {
      var box = b.closest('.gd-maps'), platz = q('.gd-maps__platz', box);
      var ifr = document.createElement('iframe'); ifr.src = box.getAttribute('data-src'); ifr.loading = 'lazy';
      ifr.setAttribute('title', 'Google Maps'); ifr.setAttribute('referrerpolicy', 'no-referrer-when-downgrade'); ifr.allowFullscreen = true;
      platz.replaceWith(ifr);
    });
  });

  /* Teilenummer-Suche: Nummer säubern (Leerzeichen/Bindestriche egal) + Kategorie als Filter */
  qa('form[data-gd-teilesuche]').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      var inp = q('[name="q"]', f), kat = q('[name="kategorie"]', f);
      var wert = (inp.value || '').trim();
      if (!wert) { e.preventDefault(); inp.focus(); return; }
      wert = wert.replace(/\s+/g, ' ');
      /* sieht nach Teilenummer aus (mind. 5 Ziffern, nur Nummernzeichen) → Bindestriche/Leerzeichen entfernen, Tags tragen die kompakte Form */
      if (/^[0-9A-Za-z \-\/.]+$/.test(wert) && (wert.match(/\d/g) || []).length >= 5) {
        var kompakt = wert.replace(/[\s\-\/.]/g, '').toUpperCase();
        wert = kompakt === wert.toUpperCase() ? kompakt : '(' + kompakt + ' OR ' + wert + ')';
      }
      if (kat && kat.value) wert = 'product_type:' + kat.value + ' AND ' + wert;
      inp.value = wert;
    });
    qa('.gd-sucher__beispiele button', f).forEach(function (b) {
      b.addEventListener('click', function () { q('[name="q"]', f).value = b.textContent.trim(); q('[name="q"]', f).focus(); });
    });
  });

  /* Sprachumschalter (Shopify localization form) */
  qa('[data-gd-sprache] button').forEach(function (b) {
    b.addEventListener('click', function () {
      var f = b.closest('form'); q('input[name="locale_code"]', f).value = b.getAttribute('data-code'); f.submit();
    });
  });
})();
